/* eslint-disable */
import universal from './universal';

// Components used on virtually every page and not worth codesplitting
export { AdvertiserDisclosure, Heading, Text } from '@nerdwallet/currency';
export { default as Composition } from '@nerdwallet/react-composition';
export { default as DocumentTitle } from 'react-document-title';
export { default as Row } from '../components/row/row';
export { default as TextBox } from '../components/text-box/text-box';
export { Tabs, TabList, Tab, TabPanel } from 'react-tabs';
export { default as VerticalSpacer } from '../components/vertical-spacer/vertical-spacer';

// Codesplit components
export const StandardProductTable = universal(
  import('@nerdwallet/react-product-table')
);

export const About = universal(import('../components/about/about'));
export const AppRow = universal(import('../components/app-row/app-row'));
export const AudioEmbed = universal(
  import('../components/audio-embed/audio-embed')
);
export const AwardsBadgeDropdown = universal(
  import('../components/awards-badge-dropdown/awards-badge-dropdown')
);
export const AwardsHero = universal(
  import('../components/awards-hero/awards-hero')
);
export const AwardsNavigation = universal(
  import('../components/awards-navigation/awards-navigation')
);
export const AwardTable = universal(
  import('../components/award-table/award-table')
);
export const BoxTable = universal(import('../components/box-table/box-table'));
export const BrandHeader = universal(
  import('../components/brand-header/brand-header')
);
export const BulletedList = universal(
  import('../components/bulleted-list/bulleted-list')
);
export const C3Chart = universal(import('../components/c3-chart/c3-chart'));
export const Calculator = universal(
  import('../components/calculator/calculator')
);
export const CategoryTiles = universal(
  import('../components/category-tiles/category-tiles.jsx')
);
export const CdsProductTable = universal(
  import('../components/cds-product-table/cds-product-table')
);
export const CdsFilters = universal(
  import('../components/cds-filters/cds-filters')
);
export const CenteredHero = universal(
  import('../components/centered-hero/centered-hero')
);
export const ChartSection = universal(
  import('../components/chart-section/chart-section')
);
export const CollapsibleParagraph = universal(
  import('../components/collapsible-paragraph/collapsible-paragraph')
);
export const CreditCardTable = universal(
  import('../components/credit-card-table/credit-card-table')
);
export const CtaBox = universal(import('../components/cta-box/cta-box'));
export const Disclosure = universal(
  import('../components/disclosure/disclosure')
);
export const Divider = universal(import('../components/divider/divider'));
export const EditableBulletedList = universal(
  import('../components/editable-bulleted-list/editable-bulleted-list')
);
export const EditableFlyOutHeader = universal(
  import('../components/editable-fly-out-header/editable-fly-out-header')
);
export const EditableFlow = universal(
  import('../components/editable-flow/editable-flow')
);
export const EditableInterestCalculator = universal(
  import(
    '../components/editable-interest-calculator/editable-interest-calculator'
  )
);
export const EditableLogoSalad = universal(
  import('../components/logo-salad/editable-logo-salad')
);
export const EditablePanelGroup = universal(
  import('../components/editable-panel-group/editable-panel-group')
);
export const EditableProductTable = universal(
  import('../components/editable-product-table/editable-product-table')
);
export const ExpandingProductTable = universal(
  import('../components/expanding-product-table/expanding-product-table')
);
export const FeatureBar = universal(
  import('../components/feature-bar/feature-bar')
);
export const FlexCard = universal(import('../components/flex-card/flex-card'));
export const FeaturedStory = universal(
  import('../components/featured-story/featured-story')
);
export const GlobalNav = universal(
  import('../components/global-nav/global-nav')
);
export const GridForm = universal(import('../components/grid-form/grid-form'));
export const HeroVideo = universal(
  import('../components/hero-video/hero-video')
);
export const IconHeader = universal(
  import('../components/icon-header/icon-header')
);
export const Image = universal(import('../components/image/image'));
export const ImageContent = universal(
  import('../components/image-content/image-content')
);
export const LabeledC3Chart = universal(
  import('../components/labeled-c3-chart/labeled-c3-chart')
);
export const LastChance = universal(
  import('../components/last-chance/last-chance')
);
export const LastUpdate = universal(
  import('../components/last-update/last-update')
);
export const MarketplaceProductCard = universal(
  import('../components/marketplace-product-card/marketplace-product-card')
);
export const NpsCrmEmail = universal(
  import('../components/nps-crm-email/nps-crm-email')
);
export const Paragraph = universal(import('../components/paragraph/paragraph'));
export const PasswordLock = universal(
  import('../components/navigate-toggle/password-lock/password-lock')
);
export const OurValues = universal(
  import('../components/our-values/our-values')
);
export const QueryParamManager = universal(
  import('../containers/query-param-manager/query-param-manager')
);
export const QueryParamSection = universal(
  import('../containers/query-param-section/query-param-section')
);
export const RowTwoCol = universal(
  import('../components/row-two-col/row-two-col')
);
export const RowTwoColOld = universal(
  import('../components/row-two-col-old/row-two-col-old')
);
export const ScrollControl = universal(
  import('../components/scroll-control/scroll-control')
);
export const ScreenSizeConditional = universal(
  import('../containers/screen-size-conditional/screen-size-conditional')
);
export const Splash = universal(import('../components/splash/splash'));
export const StandardHero = universal(
  import('../components/standard-hero/standard-hero')
);
export const Story = universal(import('../containers/story/story'));
export const StoryBlock = universal(
  import('../components/story-block/story-block')
);
export const StoryCards = universal(
  import('../components/story-cards/story-cards')
);
export const TermsTable = universal(
  import('../components/terms-table/terms-table')
);
export const ThreeSteps = universal(
  import('../components/three-steps/three-steps')
);
export const TileCarousel = universal(
  import('../components/tile-carousel/tile-carousel')
);
export const ThreeSteps2 = universal(
  import('../components/three-steps-2/three-steps-2')
);
export const UniversalProductTable = universal(
  import('../components/universal-product-table/universal-product-table')
);
export const VideoEmbed = universal(
  import('../components/video-embed/video-embed')
);
export const ZigZag = universal(import('../components/zig-zag/zig-zag'));
